<template>
  <el-dialog :visible.sync="visible"
             :title="title"
             v-model="loading"
             top="100px"
             center
             width="600px">
    <el-upload class="avatar-uploader"
               :action="dataObj.host"
               :data="dataObj"
               list-type="picture"
               :multiple="false"
               :show-file-list="false"
               :before-upload="beforeUpload"
               :on-success="handleUploadSuccess">
      <img v-if="imageUrl"
           :src="imageUrl"
           class="avatar">
      <i v-else
         class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <div class="postil">上传企业Logo / 个人头像</div>
    <el-form :model="userForm"
             status-icon
             size="small"
             ref="userForm"
             label-width="120px">
      <el-form-item label="用户名："
                    prop="username">
        <el-input v-model="userForm.username"
                  disabled></el-input>
      </el-form-item>
      <el-form-item label="注册手机号："
                    prop="phone">
        <el-input v-model="userForm.phone"
                  disabled></el-input>
      </el-form-item>
      <!-- <el-form-item label="请输入验证码："
                    prop="code">
        <el-input v-model="userForm.code">
          <template slot="append">发送验证码</template>
        </el-input>
      </el-form-item> -->
      <el-form-item label="请输入新密码："
                    :rules="[{ required: true, validator: validatePass, trigger: 'blur' }]"
                    prop="password">
        <el-input type="password"
                  v-model="userForm.password"
                  auto-complete="new-password"></el-input>
      </el-form-item>
      <el-form-item label="请再次输入："
                    :rules="[{ required: true, validator: validateCheckPass, trigger: 'blur' }]"
                    prop="checkPassword">
        <el-input type="password"
                  v-model="userForm.checkPassword"
                  auto-complete="new-password"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary"
                 @click="submitForm('userForm')">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SingleUpload from '@/components/Upload/singleUpload'
import { policy } from '@/api/oss'
import { getInfo, updateUser, updatePassword } from '@/api/login'
import md5 from 'js-md5'

export default {
  name: 'PersonalInfo',
  components: {
    SingleUpload
  },
  data () {
    return {
      visible: false,
      title: null,
      loading: false,
      imageUrl: '',
      userForm: {},
      id: null,
      admin: {
        icon: null
      },
      dataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: 'http://haihaigo.oss-cn-shenzhen.aliyuncs.com'
      }
    }
  },
  methods: {
    detail () {
      this.visible = true
      this.title = '编辑个人资料'
      this.getUserInfo()
    },
    getUserInfo () {
      this.loading = true
      getInfo().then(res => {
        this.loading = false
        this.userForm = res.data
        this.imageUrl = res.data.icon
      }).catch(err => {
        this.loading = false
      })
    },
    validatePass (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    validateCheckPass (rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    beforeUpload (file) {
      let _self = this
      // 最大只能上传2M文件
      if (file.size > 2097152) {
        this.$message.error('上传失败，最大只能上传2M大小的图片')
        return false
      }
      return new Promise((resolve, reject) => {
        policy().then(response => {
          _self.dataObj.policy = response.data.policy
          _self.dataObj.signature = response.data.signature
          _self.dataObj.ossaccessKeyId = response.data.accessKeyId
          _self.dataObj.key = response.data.dir + '/' + file.uid + md5(file.name)
          _self.dataObj.dir = response.data.dir
          _self.dataObj.host = response.data.host
          resolve(true)
        }).catch(err => {
          reject(false)
        })
      })
    },
    handleUploadSuccess (res, file) {
      let imgUrl = this.dataObj.host + '/' + this.dataObj.dir + '/' + file.uid + md5(file.name)
      this.loading = true
      this.admin.icon = imgUrl
      this.id = this.$store.getters.mchtId
      updateUser(this.id, this.admin).then(res => {
        this.loading = false
        this.$store.commit('SET_AVATAR', imgUrl)
        this.imageUrl = imgUrl
        this.$message.success('头像修改成功')
      }).catch(err => {
        this.loading = false
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            userId: this.userForm.userId,
            code: '666666',
            pwd: this.userForm.password
          }
          this.loading = true
          updatePassword(params).then(res => {
            this.loading = false
            this.visible = false
            this.$message.success('修改成功，请重新登录！')
            this.$store.dispatch('LogOut').then(() => {
              location.reload()
            })
          }).catch(err => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.avatar-uploader {
  text-align: center;
  height: 100px;
}
.avatar-uploader .avatar-uploader-icon {
  border: 2px solid #8c939d;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader img {
  border: 2px solid #8c939d;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .avatar-uploader-icon:hover {
  border-color: #409eff;
  color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.postil {
  font-size: 12px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/sys/PersonalInfo.vue